const isLimitedOfferEnabled = (timeTo, { oneDayLabel, daysLabel }) => {
    return !!timeTo && !!oneDayLabel && !!daysLabel;
};
const getPrizeColor = (colorFromProps, itemColor) => {
    return itemColor === "white" || itemColor === "black" ? itemColor : colorFromProps;
};
const validateTierRestriction = (tier, levels) => {
    return tier && levels?.length ? !levels.some((level) => level.toLowerCase() === tier.toLowerCase()) : false;
};
export { getPrizeColor, isLimitedOfferEnabled, validateTierRestriction };
//# sourceMappingURL=simplifedPrizesUtils.js.map